import { createContext, useContext, useState, useEffect } from 'react';
import { verify } from '../services/authService';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (token) {
      verificationStatusData();
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }
  }, [token]);

  const verificationStatusData = async () => {
    let status = false;
    try {
      if (token) {
        const data = await verify();
        if (data.success) {
          const authToken = localStorage.getItem('token');
          setToken(authToken);
          setIsAuthenticated(true);
          status = true;
        } else {
          logout();
        }
      }
    } catch (err) {
      logout();
    } finally {
      setIsLoading(false);
    }
    return status;
  }

  useEffect(() => {
    verificationStatusData();
  }, [])


  const login = (newToken) => {
    localStorage.setItem('token', newToken);
    setToken(newToken);
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ token, isAuthenticated, login, logout, verificationStatusData, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);